import { calculateResourceCapacity } from '@hub-mono/app-modules';
import { addDays, formatDate, getDayLabel, toDate } from '@hub-mono/utils';
import { store } from '../../../../../store';
import { selectWeekDaysSetting } from '../../../../../selectors/company';
import { makeGetHolidays } from '../../../../../selectors/holidays';
import { makeResourceByIdFromMap } from '../../../../../selectors/resource';

export const applyLeftRightHtml = args => {
    const reduxState = store.getState();
    let resource = args.row.data.tags.resource;

    if (!resource && args.e) {
        resource = makeResourceByIdFromMap(args.e.data.resourceInfo?._id)(reduxState);
    }

    // const resource = args.row.data.tags.resource || args.e.data?.resourceInfo;
    const shouldCalculateDays = !args.e || !(args.e?.data?.milestone || args.e?.data?.phase || args?.e?.data.deadline);
    let workDaysLabel = '';

    const scaleHour = reduxState?.account?.preferences?.grid?.defaultScale === 'CellDuration';
    const companyWeekDaysSettings = selectWeekDaysSetting(reduxState);

    let shouldSubtractDayFromEndDate;

    if (args.multimove) {
        shouldSubtractDayFromEndDate = false;
    } else {
        shouldSubtractDayFromEndDate = !args.resizing || args.resizing === 'end';
    }

    if (shouldCalculateDays) {
        let resourceHolidays = resource?.holidays;

        if (!resourceHolidays && resource) {
            resourceHolidays = makeGetHolidays(resource.calendarIds)(reduxState);
        }

        const { workDaysCount } = calculateResourceCapacity({
            resource,
            startDate: toDate(args.start),
            endDate: addDays(toDate(args.end), shouldSubtractDayFromEndDate ? -1 : 0),
            companyWorkWeekDetails: companyWeekDaysSettings,
            holidays: resourceHolidays,
        });

        workDaysLabel = `<span class="hub_event_move_right_days"><br />(${getDayLabel(workDaysCount)})</span>`;
    }

    if (args.right?.html && !scaleHour) {
        const oneDayBefore = addDays(toDate(args.end), shouldSubtractDayFromEndDate ? -1 : 0);
        args.right.html = formatDate(oneDayBefore, 'MMMM d, yyyy') + workDaysLabel;
    }
};
